import React, { useCallback, useRef, useState } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { useDispatch } from "react-redux";
import { Button, Menu, MenuItem } from '@mui/material';
import { actions } from './Reports.redux';
import { useNavigate } from '@tanstack/react-router';
import DeletePopover from 'components/DeletePopover';



const ContentBlocksCell = (props) => {
	const { column, row } = props;
	const id                              = row.string_id,
		  dispatch                        = useDispatch(),
		  navigate                        = useNavigate(),
		  actionAnchor                    = useRef(null),
		  [ actionsOpen, setActionsOpen ] = useState(false);


	const beforeDeleteContentBlock = useCallback(() => {
		dispatch(actions.setState({
			loading: true,
		}));
	}, [ dispatch ]);

	const afterDeleteContentBlock = useCallback(() => {
		dispatch(actions.loadTemplates());
		setActionsOpen(false);
	}, [ dispatch ]);


	const handleNavigate = useCallback(() => {
		navigate({ to: `/reports/edit-content-block/${id}` });
	}, [ navigate, id ]);

	console.log(props.column.name);



	if(column.name === 'actions') {
		return (
			<Table.Cell
				{...props}
			>
				<Button
					variant="outlined"
					size="large"
					onClick={() => setActionsOpen(true)}
					ref={actionAnchor}
				>
					...
				</Button>
				<Menu
					open={actionsOpen}
					onClose={() => setActionsOpen(false)}
					anchorEl={actionAnchor.current}
				>
					<MenuItem>
						<DeletePopover
							objectType="CONTENT-BLOCK"
							objectID={id}
							afterDelete={afterDeleteContentBlock}
							beforeDelete={beforeDeleteContentBlock}
						>
							<Button variant="text" size="large" color="error">
								Delete Content Block
							</Button>
						</DeletePopover>
					</MenuItem>
				</Menu>

			</Table.Cell>
		);
	}

	return (
		<Table.Cell
			{...props}
			onClick={handleNavigate}
		/>
	);
};


export default ContentBlocksCell;
